import api from "./client";

// Referral partners (travel agencies, relocation and event agencies) that send
// us enquiries. Not clients and not suppliers: own collection and board.
export const getPartners = (params) => api.get("/partners", { params });
export const getPartner = (id) => api.get(`/partners/${id}`);
export const createPartner = (data) => api.post("/partners", data);
export const updatePartner = (id, data) => api.patch(`/partners/${id}`, data);
export const getPartnerPipeline = () => api.get("/partners/pipeline");
export const updatePartnerPipelineStage = (id, data) => api.patch(`/partners/${id}/pipeline-stage`, data);
